const dataBackend = [
  {
    title: "PHP",
    expriance: "Intermediate",
  },

  {
    title: "MySQL",
    expriance: "Experienced",
  },

  {
    title: "Laravel",
    expriance: "Experienced",
  },
];

export default dataBackend;
